import { mapActions } from 'vuex'
import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR
} from 'store/modules/notifications/types'

export default {
  methods: {
    ...mapActions([
      'addNotification'
    ]),
    successNotification (message) {
      this.addNotification({
        message,
        type: NOTIFICATION_TYPE_SUCCESS
      })
    },
    errorNotification (message) {
      this.addNotification({
        message,
        type: NOTIFICATION_TYPE_ERROR
      })
    },
    savedNotification () {
      this.successNotification('Daten erfolgreich gespeichert.')
    },
    somethingWentWrongNotification () {
      this.errorNotification('Bitte versuchen Sie es später erneut oder rufen Sie den Support.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/notifications/notifications.js